<template>
  <div class="login-widget-edit-wrap relative">
    <menu-item class="menu-item-switch" :pt="'0px'">
      <menu-background
        :background-blur-disabled="true"
        :background-name="$t('menu.backgroundMask')"
        :model="model"
        :image-disabled="true"
      ></menu-background>
    </menu-item>
    <menu-divider />
    <menu-item
      v-if="siteLoginUserInfo"
      class="menu-item-switch"
      :pt="'0px'"
      :label="$t('common.dialog')"
    >
      <menu-background
        color-circle
        blur-circle
        :background-blur-disabled="device !== 'desktop'"
        :image-disabled="true"
        :background-name="$t('menu.backgroundDialog')"
        :background-blur-name="$t('menu.radiusDialog')"
        :model="model.loginBackground"
      ></menu-background>
    </menu-item>
    <menu-item label="进入商城自动打开登陆">
      <menu-switch v-model="model.autoOpen" label="启用" />
    </menu-item>
<!--    <menu-item label="是否只使用【游戏账号登录】">-->
<!--      <menu-switch v-model="model.onlyUidLogin" label="启用" />-->
<!--    </menu-item>-->
    <menu-item
      v-if="!siteLoginUserInfo"
      class="menu-item-switch"
      :pt="'0px'"
      :label="$t('common.dialog')"
    >
      <menu-background
        color-circle
        blur-circle
        :background-blur-disabled="device !== 'desktop'"
        :image-disabled="true"
        :background-name="$t('menu.backgroundDialog')"
        :background-blur-name="$t('menu.radiusDialog')"
        :model="model.loginBackground"
      ></menu-background>
    </menu-item>
    <menu-item
      v-if="device === 'desktop'"
      :left-circle="true"
      :border-bottom="false"
      :label="$t('edit.pcloginbg')"
      size-tip="(建议比例4:4)"
      class="pt-4"
    >
      <menu-background-image :target="model.pcModalBgImg" event-key="pc-login-bg-image" />
    </menu-item>
    <menu-item
      v-if="device === 'mobile'"
      :left-circle="true"
      :border-bottom="false"
      :label="$t('edit.mbloginbg')"
      class="pt-4"
    >
      <menu-background-image :target="model.mbModalBgImg" event-key="mb-login-bg-image" />
    </menu-item>
    <menu-divider />
    <menu-item class="menu-item-switch" label="标题文本" :pt="'0px'">
      <menu-fill
        :target="model.titleTextStyle"
        target-key="target-key"
        solid-color
      />
    </menu-item>
    <menu-item label="正文文本">
      <menu-fill
        :target="model.mainTextStyle"
        target-key="mainTextStyle"
        solid-color
      />
    </menu-item>
    <menu-divider />
    <menu-item class="menu-item-switch" label="按钮填充色" :pt="'0px'">
      <menu-background
        :background-blur-disabled="true"
        :image-disabled="false"
        :model="model.buttonStyle"
      />
    </menu-item>
    <menu-item label="按钮文本">
      <menu-fill
        class="mt-4"
        solid-color
        :target="model.buttonTextStyle"
        target-key="buttonTextStyle"
      />
    </menu-item>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MenuFill from "~/components/menu/menuFill.vue";
import MenuItem from "~/components/menu/menuItem"
import MenuDivider from "~/components/menu/divider"
import MenuBackground from '~/components/menu/menuBackground.vue'
import menuBackgroundImage from "~/components/menu/menuBackgroundImage";
import MenuSwitch from "~/components/menu/menuSwitch.vue";

export default {
  name: "LoginSettingEdit",
  components: {
    MenuSwitch,
    MenuFill,
    MenuItem,
    MenuBackground,
    MenuDivider,
    menuBackgroundImage
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    device: {
      type: String,
      default: 'desktop'
    }
  },
  data() {
    return {
      tmpModel: {}
    }
  },
  computed: {
    ...mapState({
      siteLoginUserInfo: state => state.user.siteLoginUserInfo,
      userInfo: state => state.user.siteUserInfo || {},
      loginShow: state => state.user.loginShow || false, // 显示登录弹窗
      projectInfo: state => state.project.info,
    }),
  },
  methods: {
    handleShowBackgroundMenu(suggestion) {
      this.$parent && this.$parent.selectSubmenu('background', this.model, {
        suggestion
      })
    }
  }
}
</script>

<style lang="less" scoped>
.save-btn {
  width: 96px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 120px;
  background: @primary-color;
  color: @text-color;
  font-size: 16px;

  &:hover {
    color: @text-light-color;
  }
}
</style>
